<template>
  <section class="footer bg-color-theme2">
    <div class="footer-grid container pt-5 pb-md-4 pb-5">
      <div class="row">
        <section class="col-lg-3 col-md-6 col-12 order-md-0 order-1 text-right">
          <div class="footer-head text-center">
            <div class="footer-logo">
              <img src="@/assets/images/logos/logoBlack.png" alt="" />
            </div>
            <div class="mt-4 d-md-block d-none">
              <span v-if="homeData" class="fontsize-large weight-light text-color-black ml-3"
                >{{homeData.settings.site_phone_footer}}</span
              >
              <svg
                class="icon"
                width="20"
                height="20"
                stroke="#000"
                stroke-width="1.5"
              >
                <use href="@/assets/svgIcons/svgIcons.svg/#phone"></use>
              </svg>
            </div>
            <div class="d-md-none d-flex align-items-center">
              <div>
                <p v-if="homeData"
                  class="fontsize-large weight-light text-color-black ml-3 mb-2"
                >
                  {{homeData.settings.site_phone_footer}}
                </p>
              </div>
              <div>
                <svg
                  class="icon mt-n3"
                  width="20"
                  height="20"
                  stroke="#000"
                  stroke-width="1.5"
                >
                  <use href="@/assets/svgIcons/svgIcons.svg/#phone"></use>
                </svg>
              </div>
            </div>
          </div>
        </section>
        <section
          class="col-lg-6 col-12 order-lg-1 order-md-2 order-0 mt-lg-0 mt-md-5 footer-list"
        >
          <ul v-if="homeData" class="footer-list-grid text-right">
            <li v-for="(item, index) in homeData.menus.footer" :key="index">
              <router-link
                v-if="item.link == null"
                :target="item.new_tab == 1 ? '_blank' : '_parent'"
                :to="
                  $router.resolve(
                    findUrl(
                      item.linkable_type,
                      item.linkable_id,
                      item.slug,
                      item.link
                    )
                  ).href
                "
                class="fontsize-small weight-light"
              >
                <span class="fontsize-small weight-light">
                  {{ item.title }}</span
                >
              </router-link>
              <a
                v-else-if="item.link != null"
                class="fontsize-small weight-light"
                :target="item.new_tab == 1 ? '_blank' : '_parent'"
                :href="item.link"
              >
                <span class="fontsize-small weight-light">
                  {{ item.title }}</span
                >
              </a>

            </li>
          </ul>
          <NewsLetter class="d-md-none my-5"></NewsLetter>
        </section>
        <section
          class="col-lg-3 col-md-6 col-12 order-lg-2 order-md-1 order-2 text-center"
        >
          <div v-if="homeData" class="d-flex justify-content-around">
            <a v-if="homeData.settings.whatsapp" target="_blank" :href="`https://wa.me/${homeData.settings.whatsapp}`" class="bg-none ml-3">
              <svg class="icon" width="23" height="23" fill="#000">
                <use href="@/assets/svgIcons/svgIcons.svg/#whatsapp"></use>
              </svg>
            </a>
            <a  v-if="homeData.settings.telegram" target="_blank"  :href="homeData.settings.telegram"  class="bg-none ml-3">
              <svg class="icon" width="23" height="23" fill="#000">
                <use href="@/assets/svgIcons/svgIcons.svg/#telegram2"></use>
              </svg>
            </a>
            <a  v-if="homeData.settings.facebook" target="_blank" :href="homeData.settings.facebook" class="bg-none ml-3">
              <svg class="icon" width="20" height="20" fill="#000">
                <use href="@/assets/svgIcons/svgIcons.svg/#facebook"></use>
              </svg>
            </a>
            <a  v-if="homeData.settings.instagram"  target="_blank"  :href="homeData.settings.instagram" class="bg-none ml-3">
              <svg class="icon" width="20" height="20" fill="#000">
                <use href="@/assets/svgIcons/svgIcons.svg/#insta"></use>
              </svg>
            </a>
          </div>
          <div class="d-md-block d-none">
            <p class="fontsize-mini weight-light text-color-black my-4">
              جهت عصویت در خبرنامه ایمیل خود را وارد کنید!
            </p>
            <form class="newsletters" @submit.prevent="send()">
              <div
                class="fontsize-mini rounded-pill d-flex justify-content-between"
              >
                <input
                  class="text-color-black py-1 pr-3 bg-none"
                  v-model="email"
                  type="email"
                  placeholder="ایمیل..."
                />
                <button
                  type="submit"
                  class="bg-color-black py-1 rounded-pill px-3 text-white"
                >
                  عضویت
                </button>
              </div>
            </form>
          </div>
        </section>
      </div>
    </div>
    <section class="py-3 container">
      <div
        class="d-flex flex-md-row text-center flex-column justify-content-between align-items-center text-color-black weight-light fontsize12"
      >
        <span class="mb-md-0 mb-3"
          >.کلیه حقوق سایت به اينفينتي الاين تعلق دارد و کپی برداری از آن ممنوع می
          باشد</span
        >
        <span
          >
          طراحي شده توسط تيم <a target="_blank" href="https://shetabit.com" style="color:black;font-weight: bold;">شتاب </a>
          </span
        >
      </div>
    </section>
  </section>
</template>

<script>
import findUrl from "@/libraries/links/LinkResolver";

import NewsLetter from "./NewsLetter";
export default {
  name: "Footer",
  components: {
    NewsLetter
  },
  data() {
    return {
      email: ""
    };
  },
  methods: {
    findUrl,
    send() {
      if (!this.validateEmail(this.email)) {
        const options = { title: "توجه", size: "sm" };
        this.$dialogs.alert(
          "برای عضویت در خبرنامه ایمیل را به درستی وارد کنید",
          options
        );
      } else {
        const fromData = new FormData();
        fromData.append("email", this.email);
        this.$axios.post("subscribe", fromData).then((res) => {
          const options = { title: "سپاس از شما", size: "sm" };
          this.$dialogs.alert(res.data.message, options);
          this.email = "";
        });
      }
    },
    validateEmail(email) {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
    }
  },
  computed: {
    homeData(){
      return this.$root.homeData;
    }
  },
  mounted() {
    if (window.innerWidth < 768) {
      document.querySelector(".footer").style.paddingBottom = 60 + "px";
    }
  }
};
</script>

<style scoped>
.footer {
  box-shadow: 0 0 5px #0009 inset;
}
.footer-grid {
  border-bottom: 1px solid #000;
}
.footer-list-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 0.75rem 2rem;
  list-style-position: inside;
  list-style-image: url("../assets/images/others/listStyleBlack.png");
}
.footer-list-grid a,
.footer-list-grid li {
  color: #000;
}
.footer-list-grid a:hover {
  font-family: font-bold;
  color: #222;
}
.newsletters > div {
  border: 1px solid #000;
}
.footer-head {
  width: 55%;
}
.footer-logo {
  width: 100%;
}
.footer-logo img {
  width: 100%;
}
@media screen and (max-width: 991px) {
  .footer-logo {
    width: 80%;
  }
}
@media screen and (max-width: 767px) {
  .footer-list-grid {
    grid-template-columns: 1fr 1fr;
    list-style-image: url("../assets/images/others/listStyleTheme.png");
  }
  .footer-grid {
    border-bottom: 1px solid #0005;
  }
  .footer-head {
    display: flex;
    justify-content: space-around;
    width: 100%;
    margin-bottom: 3rem;
  }
  .footer-logo {
    width: 170px;
  }
}
@media screen and (max-width: 575px) {
  .footer-list-grid {
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  }
}
@media screen and (max-width: 450px) {
  .footer-logo {
    width: 30%;
  }
}
@media screen and (max-width: 300px) {
  .footer-list-grid {
    padding-right: 0;
    padding-left: 0;
  }
}
</style>
